
export const treeMapInPutData = {
  id: 1,
  name: "Delivery Unit",
  children: [
    {
      id: 2,
      name: "India",
      value: 1
    },
    {
      id: 3,
      name: "China",
      value: 1500,
      children: [
        { id: 4, name: "Backend", value: 12, children: [{ id: 41, name: "Java", value: 120}, { id: 42, name: "Python", value: 400}, ]  },
        { id: 5, name: "Frontend", value: 200 },
        { id: 6, name: "Devops", value: 600 },
        { id: 7, name: "UX", value: 180 }
      ],
    },
    {
      id: 12,
      name: "Japan",
      children: [
        { id: 13, name: "Python 1.1", value: 12 },
        {
          id: 14,
          name: "Python 1.2",
          children: [
            { id: 15, name: "Python 1.2.1", value: 12 },
            { id: 16, name: "Python 1.2.2", value: 20 },
            { id: 17, name: "Python 1.2.3", value: 30 },
            { id: 18, name: "Python 1.2.4", value: 73 },
          ],
        },
        { id: 19, name: "Python 1.3", value: 300 },
        { id: 20, name: "Python 1.4", value: 743 },
      ],
    },
    { id: 21, name: "Italy", value: 500 },
    { id: 22, name: "Norway", value: 300 },
    {
      id: 23,
      name: "Germany",
      value: 150,
      children: [
        { id: 24, name: "C++ 1.1", value: 12 },
        { id: 25, name: "C++ 1.2", value: 200 },
        { id: 26, name: "C++ 1.3", value: 300 },
        { id: 27, name: "C++ 1.4", value: 743 },
      ],
    }
  ],
}